import { Component } from '@angular/core';

@Component({
  selector: 'app-docu-upsell-saves-dialog',
  templateUrl: './docu-upsell-saves-dialog.component.html',
  styleUrls: ['./docu-upsell-saves-dialog.component.scss'],
})
export class DocuUpsellSavesDialogComponent {}
